import * as React from 'react';
import PropTypes from 'prop-types';
import SvgContainer from './SvgContainer';

export const defaultSvgIconProps = {
  size: 'medium'
};

export const InstagramIcon = ({ size }) => {
  return (
    <SvgContainer size={size}>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_670_1328)">
          <path
            d="M18.0182 0H6.68764C3.00002 0 0 2.9143 0 6.49657V17.5036C0 21.0857 3.00002 24 6.68764 24H18.0184C21.7058 24 24.7058 21.0857 24.7058 17.5036V6.49657C24.7058 2.9143 21.7058 0 18.0182 0V0ZM23.2575 17.5036C23.2575 20.3098 20.9072 22.593 18.0182 22.593H6.68764C3.79865 22.593 1.44836 20.3098 1.44836 17.5036V6.49657C1.44836 3.69012 3.79865 1.40698 6.68764 1.40698H18.0184C20.9072 1.40698 23.2575 3.69012 23.2575 6.49657V17.5036Z"
            fill="white"
          />
          <path
            d="M12.353 5.43799C8.62802 5.43799 5.59766 8.38177 5.59766 12.0003C5.59766 15.6188 8.62802 18.5626 12.353 18.5626C16.0779 18.5626 19.1083 15.6188 19.1083 12.0003C19.1083 8.38177 16.0779 5.43799 12.353 5.43799ZM12.353 17.1556C9.42684 17.1556 7.04602 14.843 7.04602 12.0003C7.04602 9.15777 9.42684 6.84497 12.353 6.84497C15.2793 6.84497 17.6599 9.15777 17.6599 12.0003C17.6599 14.843 15.2793 17.1556 12.353 17.1556Z"
            fill="white"
          />
          <path
            d="M19.2696 3.10693C18.1688 3.10693 17.2734 3.97687 17.2734 5.04602C17.2734 6.11535 18.1688 6.98528 19.2696 6.98528C20.3703 6.98528 21.2659 6.11535 21.2659 5.04602C21.2659 3.97668 20.3703 3.10693 19.2696 3.10693ZM19.2696 5.57812C18.9676 5.57812 18.7218 5.33935 18.7218 5.04602C18.7218 4.7525 18.9676 4.51391 19.2696 4.51391C19.5717 4.51391 19.8175 4.7525 19.8175 5.04602C19.8175 5.33935 19.5717 5.57812 19.2696 5.57812Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_670_1328">
            <rect width="24.7059" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgContainer>
  );
};

InstagramIcon.propTypes = {
  size: PropTypes.string
};

// InstagramIcon.defaultProps = defaultSvgIconProps;

export default InstagramIcon;
